import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import Breadcrumb from '../Breadcrumb';
import RoomGallery from '../RoomGallery';
import RoomInfo from '../RoomInfo';
import RoomAmenities from '../RoomAmenities';
import RoomCalendar from '../RoomCalendar';
import BookingCard from '../BookingCard';
import RoomsData from '../../data/rooms.json'

import './RoomDetailPage.css';
import { LanguageContext } from '../../context/LanguageContext';

// Datos de ejemplo para la habitación

const RoomDetailPage = () => {
  const { t, language } = useContext(LanguageContext);
  const { id } = useParams();
  const RoomData = RoomsData.data.find(element => element.id == id);

  window.scroll(0, 0);

  return (
    <div className="relative flex min-h-screen w-full flex-col overflow-x-hidden">
      <div className="layout-container flex h-full grow flex-col">
        <main className="flex flex-col items-center w-full">
          <div className="room-detail-container">
            <Breadcrumb
              items={[
                { label: t("nav", "home"), href: `/${language.value}/` },
                { label: t("nav", "rooms"), href: `/${language.value}/rooms` },
                { label: t("roomTypes", "rooms")[RoomData.key]["title"], href: null }
              ]}
            />



            <RoomGallery images={RoomData.images} />
            <RoomInfo
              title={t("roomTypes", "rooms")[RoomData.key]["title"]}
              features={RoomData.features}
            />
            <div className="room-detail-grid">
              <div className="room-detail-main">
                <section className="room-section">
                  <h2 className="room-section-title">{t("roomDetail", "aboutRoom")}</h2>
                  <p className="room-section-text">{t("roomTypes", "rooms")[RoomData.key]["longDescription"]}</p>
                </section>

                <RoomAmenities amenities={RoomData.amenities} />

                {/*<RoomCalendar />*/}
              </div>
              <div className="room-detail-sidebar">
                <BookingCard price={RoomData.minprice} />
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default RoomDetailPage;